import { SelectablePill } from "@/components/form/selectable-pill";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useState } from "react";

interface OptionsPillGroupProps {
  label: string;
  options: string[];
  selectedOptions: Set<string>;
  onToggleOption: (option: string) => void;
  bgColor?: "transparent" | "white" | "black";
  disabled?: boolean;
  maximumDisplayNumber?: number;
  classNames?: {
    moreButton?: string;
  };
}

export const OptionsPillGroup: React.FC<OptionsPillGroupProps> = ({
  label,
  options,
  selectedOptions,
  onToggleOption,
  disabled = false,
  maximumDisplayNumber,
}) => {
  const [showAll, setShowAll] = useState(false);

  const displayedOptions =
    maximumDisplayNumber !== undefined && !showAll
      ? options.slice(0, maximumDisplayNumber)
      : options;

  const shouldShowMoreButton =
    maximumDisplayNumber !== undefined && options.length > maximumDisplayNumber && !showAll;

  return (
    <div className="flex flex-col gap-4">
      <h3 className={cn(textVariants.bodySingleLine, "text-black")} style={{ fontWeight: 700 }}>{label}</h3>
      <div className="grid grid-cols-2 gap-3">
        {displayedOptions.map((option) => (
          <SelectablePill
            key={option}
            label={option}
            selected={selectedOptions.has(option)}
            onClick={() => !disabled && onToggleOption(option)}
          />
        ))}
        {shouldShowMoreButton && (
          <SelectablePill
            plus
            label={`Add ${label}`}
            onClick={() => !disabled && setShowAll(true)}
          />
        )}
      </div>
    </div>
  );
};
